<template>
  <div class="header">
    <el-popover ref="popover1"
                placement="top-start"
                trigger="hover">
      <el-card class="box-card">
        <div slot="header"
             class="clearfix">
          <span>账户信息</span>
          <el-button style="float: right; padding: 3px 0; color:blue;"
                     type="text"
                     @click='dialogFormVisible=true'>修改密码</el-button>
        </div>
        <!-- <div class="card-mainter">
          <p>
            所在部门：
            <span>销售部</span>
          </p>
          <br />
          <p>
            本次登陆：
            <span>2017-12-5 12:25:58</span>
          </p>
          <br />
          <p>
            登录地区：
            <span>广东省深圳市</span>
          </p>
          <br />
          <p>
            上次登录：
            <span>2015-06-15 15:25:58</span>
          </p>
        </div> -->
      </el-card>
    </el-popover>
    <!-- <el-popover ref="popover2" placement="top-start" title="系统首页" width="200" trigger="hover"></el-popover> -->
    <!-- <el-popover ref="popover3" placement="top-start" title="退出登录" width="200" trigger="hover"></el-popover> -->
    <el-row>
      <el-col :span="12">
        <img src="@/assets/logo.jpg"
             class="imgs" />
        <p>售电管理系统</p>
      </el-col>
      <el-col :span="12">
        <ul class="userRight">
          <li v-popover:popover1
              class="user">
            <div class="userImg">
              <img src="@/assets/u134.png"
                   class="image" />
            </div>
            <span class="userName">{{this.user}}</span>
          </li>
          <li v-popover:popover2>
            <img src="@/assets/sy.png"
                 @click="handlePage"
                 title="首页"
                 style="margin-top:4px" />
          </li>
          <li v-popover:popover3>
            <img src="@/assets/on.png"
                 @click="handleLogout"
                 title='退出登录'
                 style="margin-top:6px" />
          </li>
        </ul>
      </el-col>
    </el-row>
    <el-dialog title="修改密码"
               :visible.sync="dialogFormVisible"
               width="500px">
      <el-form :model="form"
               label-width="100px"
               ref="form">
        <el-form-item label="原密码">
          <el-input v-model="form.oldpassword"
                    autocomplete="off"
                    :rules="[
      { required: true, message: '不能为空',trigger: 'blur'},
    ]"></el-input>
        </el-form-item>
        <el-form-item label="登录密码"
                      prop="password"
                      :rules="[
      { required: true, message: '不能为空',trigger: 'blur'},
            {  validator: validatePass1, trigger: 'blur'}
    ]">
          <el-input v-model="form.password"></el-input>
        </el-form-item>
        <el-form-item label="确认密码"
                      prop="password1"
                      :rules="[
      {  validator: validatePass2, trigger: 'blur'}
    ]">
          <el-input v-model="form.password1"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary"
                   @click="save">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getverify, putpassword, logout } from '../../../API'
import { Encrypt } from '../../../util/secret.js'
export default {
  data () {
    return {
      user: "admin",
      dialogFormVisible: false,
      form: {},
      validatePass1: (rule, value, callback) => {
        if (this.isSimplePwd(value) < 3) {
          callback(new Error('必须包含数字、小写字母、大写字母'));
        }
        else {
          callback();
        }
      },
      validatePass2: (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.form.password) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      },
    };
  },
  created () {
    this.user = localStorage.getItem('username');
  },
  methods: {
    handleLogout () {
      this.$confirm("确认退出吗？", "退出提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
          // 清空本地存储中的 user_info
          // window.localStorage.removeItem('user_info')
          // 跳转到登录页
          logout().then(res =>{
            if(res.code === 0){
              this.$router.push({ name: "login" });
              this.$message({
                type: "success",
                message: "退出成功!"
              });
            }
          })
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消退出"
          });
        });
    },
    handlePage () {
      this.$router.push('/sy/xtsy');
    },
    save () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          getverify({oldpassword:Encrypt(this.form.oldpassword)}).then(res => {
            if (res.code == 0) {
              putpassword(Encrypt(this.form.password)).then(res => {
                if (res.code == 0) {
                  this.$message({
                    type: "success",
                    message: "修改成功!请重新登陆"
                  });
                  let that = this
                  setTimeout(
                    function () {
                      that.$router.push('/login')
                    }, 1000
                  )
                }
              })
            }
          })
        }
      }
      )
    },
    isSimplePwd (s) {
      if (s.length < 6) {
        return 0;
      }
      var ls = 0;
      if (s.match(/([a-z])+/)) {
        ls++;
      }
      if (s.match(/([0-9])+/)) {
        ls++;
      }
      if (s.match(/([A-Z])+/)) {
        ls++;
      }
      if (s.match(/[^a-zA-Z0-9]+/)) {
        ls++;
      }
      return ls;
    },
  }
};
</script>

<style lang='less' scoped>
.header {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  height: 70px;
  font-size: 22px;
  color: #fff;
}
.imgs {
  width: 40px;
  height: 40px;
  margin-bottom: 8px;
  padding-left: 0;
  vertical-align: middle;
  display: inline-block;
  float: none;
}
.el-card.is-always-shadow,
.el-card.is-hover-shadow:focus,
.el-card.is-hover-shadow:hover {
  box-shadow: none;
}
p {
  float: left;
  padding-left: 5px;
  float: none;
  display: inline-block;
  vertical-align: middle;
}
.userRight {
  height: 50px;
  float: right;
}
li {
  display: inline-block;
  padding: 0 25px 0 25px;
  vertical-align: middle;
  height: 30px;
  line-height: 30px;
  border-right: 2px solid #ccc;
  cursor: pointer;
}
li:nth-child(3) {
  border-right: 0;
}
.user {
  height: 30px;
  margin: 10px 0 10px 0;
  vertical-align: middle;
}
.userImg {
  float: left;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  overflow: hidden;
  // background-color: pink;
}
.userImg img {
  width: 30px;
  height: 30px;
}
.userName {
  display: inline-block;
  margin-left: 5px;
  float: right;
}

.text {
  font-size: 14px;
}

.item {
  margin-bottom: 18px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both;
}

.box-card {
  width: 380px;
  background-color: transparent;
  border: none;
}
.card-mainter p {
  margin-bottom: 15px;
}
</style>
